import { ViewList } from '@mui/icons-material';
import DeleteIcon from '@mui/icons-material/Delete';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import NotificationsIcon from '@mui/icons-material/Notifications';
import OfflineShareIcon from '@mui/icons-material/OfflineShare';
import ReviewsIcon from '@mui/icons-material/Reviews';
import ThumbsUpDownIcon from '@mui/icons-material/ThumbsUpDown';
import UpdateIcon from '@mui/icons-material/Update';
import VideocamIcon from '@mui/icons-material/Videocam';
import VideoCameraFrontIcon from '@mui/icons-material/VideoCameraFront';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { Alert, Avatar, Box, Button, CircularProgress, Paper, Snackbar, Stack, Table, TableBody, TableCell, TableFooter, TableHead, TablePagination, TableRow, TableSortLabel, Tooltip } from '@mui/material';
import { deleteObjectApi, getObjectListByPropertyApi, postSaveObjectApi, putUpdateObjectApi } from 'api/general';
import { getUserListApi } from 'api/meeting';
import { sendMailByMeetingIdPDFApi } from 'api/notification';
import AddUpdateMeetingDialog from 'app/components/Dialog/AddUpdateMeetingDialog';
import MeetingUsersDialog from 'app/components/Dialog/MeetingUsersDialog';
import PreviewMeetingDialog from 'app/components/Dialog/PreviewMeetingDialog';
import ReportMenuGroup from 'app/components/ReportMenuGroup';
import VideoMenuGroup from 'app/components/VideoMenuGroup';
import { getLocaleDateWithTimeCustom, getUnitName, getUserFullName, isRoleCheckList, sortByProperty, swal_error, mailSmsTextType, getMeetingTitleByMeeting, getAddDateSuffix, getLocaleDateCustom } from 'app/utils/appHelpers';
import { CRON_DATA, DECISION, MEETING_USER, MEETINGS } from 'app/utils/constants/customConstant';
import { addMeetingToReduxList, getMeetingListFromStateByPageType, updateMeetingInReduxList, updateMeetingListAction } from 'app/utils/meetingReduxHelpers';
import config, { grayColor, greenColor } from 'config';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setAllMMList, setCurrentMeeting, setCurrentMeetingParticipants, setCurrentMeetingUsers } from 'stores/meeting';
import { useTemplateFontSettings } from 'styles/templateFontSettings';
import Swal from 'sweetalert2';
import MeetingDataTableFilter from './MeetingDataTableFilter';
import MeetingDataTableToolbar from "./MeetingDataTableToolbar";

function MeetingDataTable({ column, pageTitle, loading, setLoading }) {

    const dispatch = useDispatch();
    const authUser = useSelector(state => state.auth.authUser);
    const userRoles = authUser && authUser.userRoles;

    const pageType = useSelector((state) => state.meeting.pageType);
    const { data: userList } = useSelector(state => state.user);
    const allMeetingList = useSelector(state => state.meeting.allMeetingList);
    const allMMList = useSelector(state => state.meeting.allMMList);
    const meetingStore = useSelector((state) => state.meeting);

    const [data, setData] = useState([]);
    const [data2, setData2] = useState([]);
    const [order, setOrder] = useState("asc");
    const [orderBy, setOrderBy] = useState();
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [addMeetingDialogStatus, setAddMeetingDialogStatus] = useState();
    const [userType, setUserType] = useState("");
    const [userListData, setUserListData] = useState([]);
    const [loadingUserList, setLoadingUserList] = useState(false);
    const [openUserList, setOpenUserList] = useState(false);
    const unitList = useSelector(state => state.unit.data || []);
    const [previewMeetingDialogStatus, setPreviewMeetingDialogStatus] = useState(false);
    const [selectedPreviewMeeting, setSelectedPreviewMeeting] = useState(null);
    const [copySuccess, setCopySuccess] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState("");

    const isManagementPage = pageType && (pageType === "1" || pageType === "3");

    useEffect(() => {

        const meetingList = getMeetingListFromStateByPageType({ meetingStore });
        setData(meetingList);
        setData2(meetingList);
    }, [meetingStore.allMeetingList, meetingStore.allUsersMeetingList, meetingStore.pageType]);


    const updateCurrentList = (newList) => {
        dispatch(updateMeetingListAction(newList));
    };

    const handleUserListButtonClick = async (id, type) => {

        Swal.fire({
            title: 'İşleminiz gerçekleştiriliyor...',
            html: '<div><CircularProgress /></div>',
            allowOutsideClick: false,
            showConfirmButton: false,
            customClass: {
                container: 'swal-container-custom'
            },
            didOpen: () => Swal.showLoading()
        });

        try {
            let data = await getUserListApi(id, userList);

            data = data.filter(x => x.type === type)
            setUserListData(data);
        } catch (error) {
            console.error("Kullanıcı listesi alınamadı:", error);
        } finally {
            if (type === 1) {
                setUserType("Toplantının Üyeleri")
            } else {
                setUserType("Toplantının Katılımcıları")
            }
        }
        setOpenUserList(true);
        Swal.close();

    };

    const afterUpdateFunc = (item) => {

        let tmp = [...data];
        const index = data.findIndex(x => x.id === item.id);
        index !== -1 ? tmp[index] = item : tmp.push({ ...item, id: Number(data[data.length - 1].id) + 1 })

        setData([...tmp]);
        setData2([...tmp]);
        const newList = updateMeetingInReduxList(allMeetingList, item);

        updateAllMMList(item) // subtypelarda da guncellenenlerin yansımasi icin SAKINNNN silme
        updateCurrentList(newList);


    }


    const updateAllMMList = (item) => {
        let datalist = [...allMMList];
        let tmp = datalist;
        const index = datalist.findIndex(x => x.id === item.id);
        index !== -1 ? tmp[index] = item : tmp.push({ ...item, id: Number(datalist[datalist.length - 1].id) + 1 })

        let newList = [];

        if (item.active === 0) {
            newList = datalist.filter(meeting => meeting.id !== item.id);
        }
        newList = datalist.map((meeting) =>
            meeting.id === item.id ? item : meeting
        );

        dispatch(setAllMMList(newList));
    }

    const addAfterTable = (meeting) => {
        let tmp = [...data];
        tmp.unshift(meeting);
        setData([...tmp]);
        setData2([...tmp]);
        if (allMeetingList.length > 0) {
            const newList = addMeetingToReduxList(allMeetingList, meeting);
            updateCurrentList(newList);
        }
        addAllMMList(meeting)
    }

    const addAllMMList = (meeting) => {
        let datalist = [...allMMList];
        let tmp = datalist;
        tmp.unshift(meeting);
        dispatch(setAllMMList([...tmp]));

    }

    const closeDialog = () => {
        setAddMeetingDialogStatus(false);
    };

    const handlePreviewButtonClick = async (meeting) => {
        setSelectedPreviewMeeting(meeting);
        setPreviewMeetingDialogStatus(true)
    }

    const handleUpdateButtonClick = async (meeting) => {

        let mUsers = []
        let data = [];
        let data2 = [];
        const resultMeetingMembers = await getObjectListByPropertyApi(MEETING_USER, "meetingId", meeting.id);
        data = resultMeetingMembers.data;
        data2 = resultMeetingMembers.data;
        data = sortByProperty(data, "indexNo");
        data2 = sortByProperty(data2, "indexNo");
        data.forEach(element => {
            const user = userList.find(item => item.id === element.userId);
            mUsers.push(user)
        });

        const updatedMeeting = {
            ...meeting,
            users: mUsers,
        };

        dispatch(setCurrentMeeting(updatedMeeting));

        data2.forEach(element => {
            const user = userList.find(item => item.id === element.userId);
            element.user = user;
        });
        dispatch(setCurrentMeetingUsers(data2.filter(x => x.type === 1))); // userlar ilk defa burada getiriliyor
        dispatch(setCurrentMeetingParticipants(data2.filter(x => x.type === 2))); // userlar ilk defa burada getiriliyor

        setAddMeetingDialogStatus(true)
    }

    const handleDeleteButtonClick = async (meeting) => {

        Swal.fire({
            title: "Toplantı Silme",
            text: "Toplantıyı silmek istediğinizden emin misiniz?",
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Evet',
            cancelButtonText: "Vazgeç"
        }).then(async (result) => {
            if (result.isConfirmed) {


                Swal.fire({
                    title: 'İşleminiz gerçekleştiriliyor...',
                    html: '<div><CircularProgress /></div>',
                    allowOutsideClick: false,
                    showConfirmButton: false,
                    didOpen: () => Swal.showLoading()
                });

                let decisionList = await getObjectListByPropertyApi(DECISION, "meetingId", meeting.id)
                if (decisionList.data.length > 0) {
                    swal_error("Toplantıya ait gündemler olduğundan silinemez. Lütfen önce gündemleri siliniz.", 3000)
                    return
                } else {

                    const { user, users, decisionCount, isThereReminder, ...meetingObj } = meeting;
                    meetingObj.active = 0;
                    meetingObj.adminUserId = authUser.id;
                    // meetingObj.meetingNo = 0;
                    const result = await putUpdateObjectApi(MEETINGS, meetingObj);

                    if (result.status) {

                        Swal.close();
                        afterUpdateFunc && afterUpdateFunc({ ...meetingObj });

                        Swal.fire({
                            position: 'center',
                            icon: 'success',
                            title: 'İşlem başarılı.',
                            showConfirmButton: false,
                            timer: 2000
                        });
                    }

                }


            }

        })

    }

    const actionButtonsClick = async (meetingObj, option) => {

        let meetingCopy = { ...meetingObj };
        let title = "";
        let text = "";

        if (option === "review") {
            if (meetingCopy.statReview === 0) {
                title = "Değerlendirme Başlatma";
                text = "Değerlendirmeyi başlatmak";
                meetingCopy.statReview = 1;
            } else {
                title = "Değerlendirmeyi Sonlandırma";
                text = "Değerlendirmeyi sonlandırmak";
                meetingCopy.statReview = 0;
                meetingCopy.statReviewMessage = 0;
            }
        } else if (option === "vote") {
            if (meetingCopy.statVote === 0) {
                title = "Oylama Başlatma Yeni";
                text = "Oylamayı başlatmak";
                meetingCopy.statVote = 1;
            } else {
                title = "Oylama Sonlandırma";
                text = "Oylamayı sonlandırmak";
                meetingCopy.statVote = 0;
                meetingCopy.statVoteMessage = 0;
            }
        } else if (option === "video") {
            if (meetingCopy.statVideoCall === 0) {
                title = "Video Başlatma";
                text = "Video başlatmak";
                meetingCopy.statVideoCall = 1;
            } else {
                title = "Video Sonlandırma";
                text = "Video sonlandırmak";
                meetingCopy.statVideoCall = 0;
            }
        } else if (option === "finish") {
            if (meetingCopy.statFinish === 0) {
                title = "Toplantı Güncelleme Tamamlama";
                text = "Toplantı güncellemelerinin tamamlanmasını";
                meetingCopy.statFinish = 1;
            } else {
                title = "Toplantı Güncelleme Açma";
                text = "Toplantı güncellemelerini açmayı";
                meetingCopy.statFinish = 0;
            }
        }

        const isStarting = (
            (option === "review" && meetingCopy.statReview === 1) ||
            (option === "vote" && meetingCopy.statVote === 1) ||
            (option === "video" && meetingCopy.statVideoCall === 1) ||
            (option === "finish" && meetingCopy.statFinish === 1)
        );


        if (!isStarting && (option === "vote" || option === "review")) {
            let existingCron = await getObjectListByPropertyApi(CRON_DATA, "meetingId", meetingCopy.id);
            existingCron = existingCron.data.filter(x => x.status === 1)
            if (existingCron.length > 0) {
                for (const item of existingCron.filter(x => x.optionType === option)) {
                    const res = await deleteObjectApi(CRON_DATA, item.id);

                    if (res.status) {
                        meetingCopy.isThereReminder = "0";
                    }
                }
            }
        }


        if (isStarting && (option === "finish")) {
            let existingCron = await getObjectListByPropertyApi(CRON_DATA, "meetingId", meetingCopy.id);
            existingCron = existingCron.data.filter(x => x.status === 1)
            if (existingCron.length > 0) {
                for (const item of existingCron) {
                    const res = await deleteObjectApi(CRON_DATA, item.id);
                    if (res.status) {
                        meetingCopy.isThereReminder = "0";
                    }

                }
            }
        }


        if (!isStarting) {
            Swal.fire({
                title,
                text: text + " istediğinize emin misiniz?",
                icon: 'question',
                showCancelButton: true,
                confirmButtonText: 'Evet',
                cancelButtonText: 'Vazgeç'
            }).then(async (result) => {
                if (!result.isConfirmed) return;

                // loading
                Swal.fire({
                    title: 'İşleminiz gerçekleştiriliyor...',
                    html: '<div><CircularProgress /></div>',
                    allowOutsideClick: false,
                    showConfirmButton: false,
                    didOpen: () => Swal.showLoading()
                });

                try {
                    meetingCopy.adminUserId = authUser.id;
                    let { user, users, decisionCount, isThereReminder, ...updatedMeetingObj } = meetingCopy;
                    const res = await putUpdateObjectApi(MEETINGS, updatedMeetingObj);
                    Swal.close();
                    if (res.status) {
                        afterUpdateFunc && afterUpdateFunc(meetingCopy);
                        Swal.fire({
                            position: 'center',
                            icon: 'success',
                            title: 'İşlem başarılı.',
                            showConfirmButton: false,
                            timer: 1500
                        });
                    }
                } catch (err) {
                    Swal.close();
                    Swal.fire({
                        icon: 'error',
                        title: 'Hata oluştu',
                        text: err.message || 'Beklenmedik bir hata.'
                    });
                }
            });
            return;
        }

        Swal.fire({
            title,
            html: `
            <p style="font-size:0.9rem; margin-bottom:10px;">${text} istediğinize emin misiniz?</p>
            <p style="font-style: italic; color: #666; margin-bottom: 20px; text-align: center; font-size: 0.75rem;">
                İlgililere, seçtiğiniz bildirim türü veya ek seçeneklere göre bilgi verilecek şekilde ya da hiçbirini seçmeden doğrudan işlemi başlatabilirsiniz.
            </p>
            <div style="margin-bottom: 20px; text-align: center;">
                <p style="font-weight: 500; margin-bottom: 10px; font-size: 0.85rem;">Bildirim türünü seçiniz:</p>
                <div style="display: flex; gap: 20px; justify-content: center;">
                    <label style="font-weight: normal; font-size: 0.85rem;">
                        <input type="checkbox" id="cbEmail" />
                        E‑posta
                    </label>
                    <label style="font-weight: normal; font-size: 0.85rem;">
                        <input type="checkbox" id="cbSms" />
                        SMS
                    </label>
                </div>
            </div>
            <div style="text-align: center;">
                <p style="font-weight: 500; margin-bottom: 10px; font-size: 0.85rem;">E‑posta (seçtiyseniz) ekini seçiniz:</p>
                <div style="display: flex; gap: 20px; justify-content: center;">
                    <label style="font-weight: normal; font-size: 0.85rem;">
                        <input type="checkbox" id="cbAgenda" />
                        Gündem Listesi
                    </label>
                    <label style="font-weight: normal; font-size: 0.85rem;">
                        <input type="checkbox" id="cbDecision" />
                        Karar Listesi
                    </label>
                </div>
            </div>

            ${(option === 'vote' || option === 'review') ? `
            <div style="text-align: center; margin-top: 20px;">
                <p style="font-weight: 500; margin-bottom: 10px; font-size: 0.85rem;">Hatırlatma seçeneği (Sms ve E-posta olarak):</p>
                <div style="display: flex; gap: 20px; justify-content: center;">
                    <label style="font-weight: normal; font-size: 0.85rem;">
                        <input type="checkbox" id="cbReminderOnce" onclick="if(this.checked) document.getElementById('cbReminderRecurring').checked = false;" />
                        Sadece bir kez (24 saat sonra)
                    </label>
                    <label style="font-weight: normal; font-size: 0.85rem;">
                        <input type="checkbox" id="cbReminderRecurring" onclick="if(this.checked) document.getElementById('cbReminderOnce').checked = false;" />
                        Oylama sonlanana kadar her 24 saatte bir
                    </label>
                </div>
            </div>
            ` : ''}
            `,
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Evet',
            cancelButtonText: 'Vazgeç',
            preConfirm: () => {
                let reminderType = null;

                if (option === 'vote' || option === 'review') {
                    const reminderOnce = document.getElementById('cbReminderOnce').checked;
                    const reminderRecurring = document.getElementById('cbReminderRecurring').checked;

                    if (reminderOnce) {
                        reminderType = 1;
                    } else if (reminderRecurring) {
                        reminderType = 2;
                    }
                }

                return {
                    email: document.getElementById('cbEmail').checked,
                    sms: document.getElementById('cbSms').checked,
                    agenda: document.getElementById('cbAgenda').checked,
                    decision: document.getElementById('cbDecision').checked,
                    reminderType: reminderType
                };
            }
        }).then(async (result) => {
            if (!result.isConfirmed) return;
            const { email, sms, agenda, decision, reminderType } = result.value;

            // E-posta veya SMS seçilmişse ikinci modal aç
            if (email || sms) {
                const getDefaultMailText = (option, meetingObj, agenda, decision) => {
                    const mailTexts = mailSmsTextType.find(x => x.type === option);
                    if (!mailTexts) return "";

                    let mailBodyText = mailTexts.mailBodyText;

                    if (option === "video") {

                        let saat = new Date(meetingObj.pdate).toTimeString().split(' ')[0].slice(0, 5).replace(':', '.');
                        saat = getAddDateSuffix(saat);
                        const meetingDateInfo = getLocaleDateCustom("tr", meetingObj.pdate) + " tarihinde ve saat " + saat + " video konferansa açılacaktır."

                        mailBodyText = mailBodyText + meetingDateInfo + " KURULSİS Ana sayfasındaki video konferans bölümünden veya ekteki toplantı bağlantısından toplantıya katılabilirsiniz.";

                    }

                    // Video konferans için shortUrlText ekle (e-posta için de)
                    let shortUrlText = "";
                    if (option === "video") {
                        const link = (meetingObj.meetingShortUrl !== null && meetingObj.meetingShortUrl !== undefined && meetingObj.meetingShortUrl !== "") ? meetingObj.meetingShortUrl : meetingObj.meetingUrl;
                        shortUrlText = " Toplantı bağlantısı : " + link;
                    }

                    // Ek metinleri ekle
                    let mailAttachmentText = "";
                    if (agenda && decision) {
                        mailAttachmentText = " Gündem ve karar listesi ekte bulunmaktadır.";
                    } else if (agenda) {
                        mailAttachmentText = " Gündem listesi ekte bulunmaktadır.";
                    } else if (decision) {
                        mailAttachmentText = " Karar listesi ekte bulunmaktadır.";
                    }

                    return mailBodyText + mailAttachmentText + shortUrlText;
                };

                const getDefaultSmsText = (option, meetingObj, agenda, decision) => {
                    const mailTexts = mailSmsTextType.find(x => x.type === option);
                    if (!mailTexts) return "";

                    let smsBodyText = getMeetingTitleByMeeting(meetingObj) + mailTexts.smsBodyText;

                    if (option === "video") {

                        const link = (meetingObj.meetingShortUrl !== null && meetingObj.meetingShortUrl !== undefined && meetingObj.meetingShortUrl !== "") ? meetingObj.meetingShortUrl : meetingObj.meetingUrl;
                        const shortUrlText = " Toplantı bağlantısı : " + link;
                        let saat = new Date(meetingObj.pdate).toTimeString().split(' ')[0].slice(0, 5).replace(':', '.');
                        saat = getAddDateSuffix(saat);

                        const meetingDateInfo = getLocaleDateCustom("tr", meetingObj.pdate) + " tarihinde ve saat " + saat + " video konferansa açılacaktır."
                        smsBodyText = smsBodyText + meetingDateInfo + shortUrlText;


                    }

                    return smsBodyText;
                };

                const defaultMailText = getDefaultMailText(option, meetingCopy, agenda, decision);
                const defaultSmsText = getDefaultSmsText(option, meetingCopy, agenda, decision);

                const textModalResult = await Swal.fire({
                    title: 'Bildirim Metinlerini Düzenleyin',
                    html: `
                    <div style="margin-bottom: 20px;">
                        ${email ? `
                        <div style="margin-bottom: 15px;">
                            <p style="font-weight: 400; margin-bottom: 8px; font-size: 0.7rem;">E-posta başlığı : ${getMeetingTitleByMeeting(meetingCopy)}</p>

                            <p style="font-weight: 500; margin-bottom: 8px; font-size: 0.85rem;">E-posta Metni: </p>
                            <textarea id="mailText" style="width: 100%; height: 120px; padding: 8px; border: 1px solid #ddd; border-radius: 4px; font-size: 0.8rem;" placeholder="E-posta metnini buraya yazın...">${defaultMailText}</textarea>
                        </div>
                        ` : ''}
                        ${sms ? `
                        <div style="margin-bottom: 15px;">
                            <p style="font-weight: 500; margin-bottom: 8px; font-size: 0.85rem;">SMS Metni:</p>
                            <textarea id="smsText" style="width: 100%; height: 100px; padding: 8px; border: 1px solid #ddd; border-radius: 4px; font-size: 0.8rem;" placeholder="SMS metnini buraya yazın...">${defaultSmsText}</textarea>
                        </div>
                        ` : ''}
                    </div>
                    `,
                    icon: 'question',
                    showCancelButton: true,
                    confirmButtonText: 'Gönder',
                    cancelButtonText: 'Vazgeç',
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    preConfirm: () => {
                        const mailText = email ? document.getElementById('mailText').value : null;
                        const smsText = sms ? document.getElementById('smsText').value : null;
                        return { mailText, smsText };
                    }
                });

                if (!textModalResult.isConfirmed) return;

                const { mailText, smsText } = textModalResult.value;

                // İşlemleri gerçekleştir
                await processMeetingAction(meetingCopy, option, email, sms, agenda, decision, reminderType, mailText, smsText);
            } else {
                // E-posta veya SMS seçilmemişse direkt işlemleri gerçekleştir
                await processMeetingAction(meetingCopy, option, email, sms, agenda, decision, reminderType, null, null);
            }
        });
    };

    const processMeetingAction = async (meetingCopy, option, email, sms, agenda, decision, reminderType, mailText, smsText) => {
        Swal.fire({
            title: 'İşleminiz gerçekleştiriliyor...',
            html: '<div><CircularProgress /></div>',
            allowOutsideClick: false,
            showConfirmButton: false,
            didOpen: () => Swal.showLoading()
        });

        try {
            const notType = email && sms
                ? 'mailSms'
                : email
                    ? 'mail'
                    : sms
                        ? 'sms'
                        : "false";
            const attachmentType = agenda && decision
                ? 'agendaDecision'
                : agenda
                    ? 'agenda'
                    : decision
                        ? 'decision'
                        : "false";

            await sendMailByMeetingIdPDFApi(
                meetingCopy.id,
                option,
                notType,
                attachmentType,
                mailText,
                smsText
            );

            meetingCopy.adminUserId = authUser.id;
            let { user, users, decisionCount, isThereReminder, ...updatedMeetingObj } = meetingCopy;
            if (option === 'vote') {
                updatedMeetingObj.statVoteMessage = 1;
            }
            if (option === 'review') {
                updatedMeetingObj.statReviewMessage = 1;
            }

            if (reminderType) {
                const meetingReminderRes = await getObjectListByPropertyApi(CRON_DATA, "meetingId", meetingCopy.id)

                if (meetingReminderRes.status) {
                    let meetingReminderData = meetingReminderRes.data;

                    if (meetingReminderData.length > 0) {
                        let isThereReminder = meetingReminderData.filter(x => x.optionType === option && x.status === 1)
                        if (isThereReminder.length > 0) {
                            Swal.fire({
                                position: 'center',
                                icon: 'warning',
                                title: 'Daha önce bir hatırlatma oluşturulduğudan hatırlatma eklenemedi. Diğer işlemler başarılı',
                                showConfirmButton: false,
                                timer: 3000
                            });
                            return;
                        }
                    }

                    const tzOffsetMs = new Date().getTimezoneOffset() * 60 * 1000;
                    const nextRun = new Date(Date.now() + 24 * 60 * 60 * 1000 - tzOffsetMs);

                    const cronData = {
                        meetingId: meetingCopy.id,
                        optionType: option,
                        reminderType: reminderType,
                        status: 1,
                        lastRun: null,
                        nextRun: nextRun,
                        createdAt: new Date(Date.now() - tzOffsetMs)
                    };
                    const res = await postSaveObjectApi(CRON_DATA, cronData);
                    if (res.status) {
                        let reminderNames = await getObjectListByPropertyApi(CRON_DATA, "meetingId", meetingCopy.id);
                        if (reminderNames.status) {
                            let reminderNamesData = reminderNames.data;
                            if (reminderNamesData.length > 0) {
                                meetingCopy.isThereReminder = reminderNamesData.map(x => x.optionType).join(',');
                            }
                        }
                    }
                }
            }

            const updateRes = await putUpdateObjectApi(MEETINGS, updatedMeetingObj);
            if (updateRes.status) {
                afterUpdateFunc && afterUpdateFunc(meetingCopy);
            }

            Swal.close();
            Swal.fire({
                position: 'center',
                icon: 'success',
                title: 'İşlem başarılı.',
                showConfirmButton: false,
                timer: 2000
            });

        } catch (err) {
            Swal.close();
            Swal.fire({
                icon: 'error',
                title: 'Hata oluştu',
                text: err.message || 'Beklenmedik bir hata.'
            });
        }
    };

    const handleCopyMeetingUrl = async (url) => {

        try {
            await navigator.clipboard.writeText(url);
            setSnackbarMessage("Toplantı bağlantısı kopyalandı!");
            setCopySuccess(true);
        } catch (err) {
            console.error("Kopyalama işlemi başarısız!", err);
            setSnackbarMessage("Kopyalama işlemi başarısız!");
            setCopySuccess(true);
        }
    };


    const handleRequestSort = (event, property) => {
        const tempOrderBy = property;
        let tempOrder = 'desc';

        if (orderBy === property && order === 'desc') {
            tempOrder = 'asc';
        }

        const tempdata =
            tempOrder === 'desc'
                ? data.sort((a, b) => (b[tempOrderBy] < a[tempOrderBy] ? -1 : 1))
                : data.sort((a, b) => (a[tempOrderBy] < b[tempOrderBy] ? -1 : 1));

        setData(tempdata);
        // dispatch(setMeetingListOfTheUser(tempdata));
        setOrder(tempOrder);
        setOrderBy(tempOrderBy);

    };

    const DataTableHead = ({ onRequestSort, customColumnData }) => {

        const createSortHandler = property => event => {
            onRequestSort(event, property);
        };

        return (
            <TableHead>
                <TableRow>
                    {customColumnData.map(column => {
                        return (
                            <TableCell
                                key={column.id}
                                align={column.numeric}
                                padding={column.disablePadding ? 'none' : 'normal'}
                            >
                                <Tooltip
                                    title="Sırala"
                                    placement={column.numeric ? 'bottom-end' : 'bottom-start'}
                                    enterDelay={300}
                                >
                                    <TableSortLabel
                                        active={orderBy === column.id}
                                        direction={order}
                                        onClick={createSortHandler(column.id)}
                                    >
                                        {column.label}
                                    </TableSortLabel>
                                </Tooltip>
                            </TableCell>
                        );
                    }, this)}
                </TableRow>
            </TableHead>
        );
    };

    const getReminderMessage = (isThereReminder) => {
        if (!isThereReminder || isThereReminder === '0') {
            return '';
        }

        const reminderTypes = isThereReminder.split(',').map(type => type.trim());

        if (reminderTypes.length === 1) {
            if (reminderTypes[0] === 'vote') {
                return 'Oylama için hatırlatma bulunmaktadır. Hatırlatıcıyı kaldırmak için tıklayınız';
            } else if (reminderTypes[0] === 'review') {
                return 'Değerlendirme için hatırlatma bulunmaktadır. Hatırlatıcıyı kaldırmak için tıklayınız';
            }
        } else if (reminderTypes.length === 2) {
            if (reminderTypes.includes('vote') && reminderTypes.includes('review')) {
                return 'Oylama ve değerlendirme için hatırlatma bulunmaktadır. Hatırlatıcıyı kaldırmak için tıklayınız';
            }
        }

        return 'Hatırlatma bulunmaktadır. Hatırlatıcıyı kaldırmak için tıklayınız';
    };

    const handleRemoveReminder = async (meeting) => {
        try {
            const reminderTypes = meeting.isThereReminder.split(',').map(type => type.trim());

            let selectedReminders = [];
            let confirmationText = '';

            if (reminderTypes.length === 1) {
                if (reminderTypes[0] === 'vote') {
                    confirmationText = 'Oylama hatırlatıcısını kaldırmak istediğinizden emin misiniz?';
                } else if (reminderTypes[0] === 'review') {
                    confirmationText = 'Değerlendirme hatırlatıcısını kaldırmak istediğinizden emin misiniz?';
                }
                selectedReminders = reminderTypes;
            } else if (reminderTypes.length === 2) {
                const { value: formValues } = await Swal.fire({
                    title: 'Hatırlatıcı Seçimi',
                    html: `
                        <div style="text-align: left; margin: 20px 0;">
                            <div style="margin-bottom: 15px;">
                                <label style="display: flex; align-items: center; cursor: pointer;">
                                    <input type="checkbox" id="vote-checkbox" style="margin-right: 10px;" checked>
                                    <span>Oylama Hatırlatıcısı</span>
                                </label>
                            </div>
                            <div>
                                <label style="display: flex; align-items: center; cursor: pointer;">
                                    <input type="checkbox" id="review-checkbox" style="margin-right: 10px;" checked>
                                    <span>Değerlendirme Hatırlatıcısı</span>
                                </label>
                            </div>
                        </div>
                    `,
                    showCancelButton: true,
                    confirmButtonColor: '#d33',
                    cancelButtonColor: '#3085d6',
                    confirmButtonText: 'Evet, Kaldır',
                    cancelButtonText: 'Vazgeç',
                    focusConfirm: false,
                    preConfirm: () => {
                        const voteChecked = document.getElementById('vote-checkbox').checked;
                        const reviewChecked = document.getElementById('review-checkbox').checked;

                        if (!voteChecked && !reviewChecked) {
                            Swal.showValidationMessage('En az bir hatırlatıcı seçmelisiniz');
                            return false;
                        }

                        return {
                            vote: voteChecked,
                            review: reviewChecked
                        };
                    }
                });

                if (formValues) {
                    if (formValues.vote && formValues.review) {
                        selectedReminders = ['vote', 'review'];
                        confirmationText = 'Oylama ve değerlendirme hatırlatıcılarını kaldırmak istediğinizden emin misiniz?';
                    } else if (formValues.vote) {
                        selectedReminders = ['vote'];
                        confirmationText = 'Oylama hatırlatıcısını kaldırmak istediğinizden emin misiniz?';
                    } else if (formValues.review) {
                        selectedReminders = ['review'];
                        confirmationText = 'Değerlendirme hatırlatıcısını kaldırmak istediğinizden emin misiniz?';
                    }
                } else {
                    return; // Kullanıcı iptal etti
                }
            }

            const result = await Swal.fire({
                title: 'Hatırlatıcıyı Kaldır',
                text: confirmationText,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#d33',
                cancelButtonColor: '#3085d6',
                confirmButtonText: 'Evet, Kaldır',
                cancelButtonText: 'İptal'
            });

            if (result.isConfirmed) {
                Swal.fire({
                    title: 'İşleminiz gerçekleştiriliyor...',
                    html: '<div><CircularProgress /></div>',
                    allowOutsideClick: false,
                    showConfirmButton: false,
                    didOpen: () => Swal.showLoading()
                });

                let updatedMeeting = { ...meeting };
                let currentReminders = updatedMeeting.isThereReminder.split(',').map(type => type.trim());

                const cronDataResponse = await getObjectListByPropertyApi(CRON_DATA, "meetingId", meeting.id);

                if (cronDataResponse.status && cronDataResponse.data.length > 0) {
                    for (const cronItem of cronDataResponse.data) {
                        if (selectedReminders.includes(cronItem.optionType)) {
                            const res = await deleteObjectApi(CRON_DATA, cronItem.id);
                            if (res.status) {
                                currentReminders = currentReminders.filter(type => type !== cronItem.optionType);
                            }
                        }
                    }
                }

                updatedMeeting.isThereReminder = currentReminders.length > 0 ? currentReminders.join(',') : '0';


                let tmp = [...data];
                const index = data.findIndex(x => x.id === meeting.id);
                if (index !== -1) {
                    tmp[index] = updatedMeeting;
                    setData([...tmp]);
                    setData2([...tmp]);
                }

                afterUpdateFunc(updatedMeeting);

                Swal.close();

                let successMessage = '';
                if (selectedReminders.length === 1) {
                    if (selectedReminders[0] === 'vote') {
                        successMessage = 'Oylama hatırlatıcısı başarıyla kaldırıldı.';
                    } else if (selectedReminders[0] === 'review') {
                        successMessage = 'Değerlendirme hatırlatıcısı başarıyla kaldırıldı.';
                    }
                } else if (selectedReminders.length === 2) {
                    successMessage = 'Oylama ve değerlendirme hatırlatıcıları başarıyla kaldırıldı.';
                }

                Swal.fire({
                    position: 'center',
                    icon: 'success',
                    title: successMessage,
                    showConfirmButton: false,
                    timer: 2000
                });
            }
        } catch (error) {
            Swal.close();
            Swal.fire({
                icon: 'error',
                title: 'Hata oluştu',
                text: error.message || 'Hatırlatıcı kaldırılırken bir hata oluştu.'
            });
        }
    };


    const { baseFontSize, fabStyle, paginationStyle, buttonStyle, iconFontSize, tableCellStyle } = useTemplateFontSettings();



    return (

        <Paper className="col-md-12">


            {
                loading ? (

                    <CircularProgress size={100} />

                ) : (


                    <>

                        <MeetingDataTableToolbar
                            pageTitle={pageTitle}
                            data2={data2}
                            setData={setData}
                            afterUpdateFunc={afterUpdateFunc}
                            addAfterTable={addAfterTable}
                            isManagementPage={isManagementPage}
                        />
                        <MeetingDataTableFilter data={data2} setFilterData={(data) => setData(data)} setPage={setPage} />
                        <div className="flex-auto">
                            <div className="table-responsive-material">
                                <Table
                                    sx={{
                                        '& th, & td': {
                                            fontSize: baseFontSize
                                        }
                                    }}
                                    size="small"
                                >
                                    <DataTableHead
                                        order={order}
                                        orderBy={orderBy}
                                        onRequestSort={handleRequestSort}
                                        rowCount={data.length}
                                        customColumnData={column}
                                    />

                                    <TableBody>
                                        {data.length > 0 ? (
                                            data.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map(n => {
                                                const isEditable = !(n.statFinish === 1 || !isManagementPage);
                                                const user = userList.find(x => x.id === n.adminUserId);

                                                return (
                                                    <TableRow hover key={"trO" + n.id}>
                                                        <TableCell align="left" padding="normal">{n.id}</TableCell>
                                                        <TableCell align="left" padding="normal">{n.inst}</TableCell>
                                                        <TableCell align="left" padding="none">
                                                            {
                                                                getUnitName(n.unitId, unitList)
                                                            }
                                                        </TableCell>
                                                        <TableCell align="left" padding="none" sx={{ ...tableCellStyle, paddingLeft: 2 }}>{n.meetingNo}</TableCell>
                                                        <TableCell align="left" padding="none" sx={tableCellStyle}>
                                                            {getLocaleDateWithTimeCustom("tr", n.pdate)}
                                                        </TableCell>
                                                        <TableCell align="center" padding="none">
                                                            <Box display="flex" alignItems="center" gap={1}>

                                                                <Avatar
                                                                    alt=""
                                                                    src={(user && user.profileImageUrl) ? config.userAuthApiUrl + user.profileImageUrl : config.userAuthApiUrl + config.defaultProfileImageUrl}
                                                                    onError={(e) => { e.target.onerror = null; e.target.src = config.userAuthApiUrl + config.defaultProfileImageUrl }}
                                                                    style={{ ...fabStyle }}

                                                                />

                                                                <span>{getUserFullName(user)}</span>
                                                            </Box>
                                                        </TableCell>
                                                        <TableCell align="left" padding="none" sx={{ ...tableCellStyle, paddingLeft: 3 }}>{n.decisionCount}</TableCell>
                                                        <TableCell align="left" padding="none">
                                                            <Button color="primary" onClick={() => handleUserListButtonClick(n.id, 1)}>
                                                                <ViewList />
                                                            </Button>
                                                        </TableCell>
                                                        <TableCell align="left" padding="none">
                                                            <Button color="warning" onClick={() => handleUserListButtonClick(n.id, 2)}>
                                                                <ViewList />
                                                            </Button>
                                                        </TableCell>
                                                        {isManagementPage && isRoleCheckList(userRoles, [1, 370, 373, 369, 372]) ? (
                                                            <TableCell align="center" padding="none">


                                                                <Stack direction="row" sx={{ p: '1px' }}>


                                                                    <Tooltip title={n.statReview === 0 ? "Değerlendirmeyi Başlat" : "Değerlendirmeyi Sonlandır"}
                                                                        placement="top"
                                                                        arrow
                                                                    >
                                                                        <Button
                                                                            variant="inherit"
                                                                            sx={buttonStyle}
                                                                            onClick={() => {
                                                                                if (!isEditable || (n.statFinish === 1 && n.statReview !== 0)) return;
                                                                                actionButtonsClick(n, 'review');
                                                                            }}
                                                                            disabled={!isEditable || (n.statFinish === 1 && n.statReview !== 0)}
                                                                        >
                                                                            <ReviewsIcon
                                                                                sx={{
                                                                                    fontSize: iconFontSize,
                                                                                    color: n.statFinish === 1 ? grayColor : n.statReview === 0 ? grayColor : greenColor,
                                                                                    cursor: !isEditable || (n.statFinish === 1 && n.statReview !== 0)
                                                                                        ? 'not-allowed'
                                                                                        : 'pointer'
                                                                                }}
                                                                            />
                                                                        </Button>
                                                                    </Tooltip>
                                                                    <Tooltip title={n.statVote === 0 ? "Oylamayı Başlat" : "Oylamayı Sonlandır"}
                                                                        placement="top"
                                                                        arrow
                                                                    >
                                                                        <Button
                                                                            variant="inherit"
                                                                            sx={buttonStyle}
                                                                            onClick={() => {
                                                                                if (!isEditable || (n.statFinish === 1 && n.statVote !== 0)) return;
                                                                                actionButtonsClick(n, 'vote');
                                                                            }}
                                                                            disabled={!isEditable || (n.statFinish === 1 && n.statVote !== 0)}
                                                                        >
                                                                            <ThumbsUpDownIcon
                                                                                sx={{
                                                                                    fontSize: iconFontSize,
                                                                                    color: n.statFinish === 1 ? grayColor : n.statVote === 0 ? grayColor : greenColor,
                                                                                    cursor: !isEditable || (n.statFinish === 1 && n.statVote !== 0)
                                                                                        ? 'not-allowed'
                                                                                        : 'pointer'
                                                                                }}
                                                                            />
                                                                        </Button>
                                                                    </Tooltip>
                                                                    <Tooltip
                                                                        title={n.statFinish === 1 ? "" : (n.meetingUrl === '' ? "Önce toplantı bağlantısı oluşturulmalı" : (n.statVideoCall === 0 ? "Toplantı Video Konferansı Başlat" : "  Toplantı Video Konferansı Sonlandır"))}
                                                                        placement="top"
                                                                        arrow
                                                                        disableHoverListener={n.statFinish === 1}
                                                                        disableFocusListener={n.statFinish === 1}
                                                                        disableTouchListener={n.statFinish === 1}
                                                                    >
                                                                        <span>
                                                                            <Button
                                                                                variant="inherit"
                                                                                sx={buttonStyle}
                                                                                onClick={() => {
                                                                                    if (!isEditable || n.meetingUrl === '' || (n.statFinish === 1 && n.statVideoCall !== 0)) return;
                                                                                    actionButtonsClick(n, 'video');
                                                                                }}
                                                                                disabled={!isEditable || n.meetingUrl === '' || (n.statFinish === 1 && n.statVideoCall !== 0)}

                                                                            >
                                                                                <VideocamIcon
                                                                                    sx={{
                                                                                        fontSize: iconFontSize,
                                                                                        color: n.statFinish === 1 ? grayColor : n.statVideoCall === 0 ? grayColor : greenColor,
                                                                                        cursor: !isEditable || n.meetingUrl === '' || (n.statFinish === 1 && n.statVideoCall !== 0)
                                                                                            ? 'not-allowed'
                                                                                            : 'pointer'
                                                                                    }}
                                                                                />
                                                                            </Button>
                                                                        </span>
                                                                    </Tooltip>
                                                                    <Tooltip title={n.statFinish === 0 ? "Toplantıyı Tamamla" : "Toplantıyı Güncellemeye Aç"}
                                                                        placement="top"
                                                                        arrow
                                                                    >
                                                                        <Button

                                                                            variant="inherit"
                                                                            sx={buttonStyle}
                                                                            onClick={() => actionButtonsClick(n, 'finish')}
                                                                            disabled={(!isEditable && !isManagementPage)}
                                                                        >
                                                                            <DoneAllIcon
                                                                                sx={{
                                                                                    fontSize: iconFontSize,
                                                                                    color: n.statFinish === 0 ? grayColor : greenColor,
                                                                                    cursor: (isEditable || isManagementPage) ? 'pointer' : 'not-allowed'
                                                                                }}
                                                                            />
                                                                        </Button>
                                                                    </Tooltip>


                                                                    {n.isThereReminder && n.isThereReminder !== '0' && (
                                                                        <Tooltip
                                                                            title={getReminderMessage(n.isThereReminder)}
                                                                            placement="top"
                                                                            arrow
                                                                        >
                                                                            <Box component="span" sx={{ display: 'inline-flex' }}>
                                                                                <Button
                                                                                    color="warning"
                                                                                    sx={buttonStyle}
                                                                                    onClick={() => handleRemoveReminder(n)}
                                                                                >
                                                                                    <NotificationsIcon
                                                                                        sx={{
                                                                                            fontSize: iconFontSize,
                                                                                            color: '#ff9800'
                                                                                        }}
                                                                                    />
                                                                                </Button>
                                                                            </Box>
                                                                        </Tooltip>
                                                                    )}




                                                                </Stack>
                                                            </TableCell>
                                                        ) : null}
                                                        <TableCell align="left" padding="none">
                                                            <>
                                                                {isEditable ? (
                                                                    <Tooltip
                                                                        placement="top"
                                                                        arrow
                                                                        title={(n.meetingUrl && n.meetingUrl !== undefined) ? "Toplantı Bağlantısını Kopyala" : "Toplantı Bağlantısı Oluşturulmamış"}
                                                                    >
                                                                        <Box sx={{ display: 'inline-flex' }}>
                                                                            <Button
                                                                                key={n.meetingUrl}
                                                                                color={n.meetingUrl ? "primary" : "inherit"}
                                                                                sx={buttonStyle}
                                                                                disabled={n.meetingUrl === ""}
                                                                                onClick={() => handleCopyMeetingUrl(n.meetingShortUrl ? n.meetingShortUrl : n.meetingUrl)}
                                                                            >
                                                                                <OfflineShareIcon sx={{ fontSize: iconFontSize }} />
                                                                            </Button>
                                                                        </Box>
                                                                    </Tooltip>
                                                                ) : null}


                                                                {isEditable ? (
                                                                    <Tooltip title={n.meetingUrl ? "Çevrim içi toplantıya katılmak için tıklayınız" : "Toplantı bağlantısı bulunmamaktadır"}
                                                                        placement="top"
                                                                        arrow
                                                                    >
                                                                        <Box sx={{ display: 'inline-flex' }}>
                                                                            <Button

                                                                                color={n.meetingUrl ? "primary" : "inherit"}
                                                                                sx={buttonStyle}
                                                                                disabled={n.meetingUrl === ""}
                                                                                onClick={() => {
                                                                                    if (n.meetingUrl) {
                                                                                        window.open(n.meetingUrl, '_blank');
                                                                                    }
                                                                                }}
                                                                            >
                                                                                <VideoCameraFrontIcon
                                                                                    sx={{
                                                                                        fontSize: 20,
                                                                                        color: n.meetingUrl ? "primary" : grayColor,
                                                                                        cursor: n.meetingUrl ? 'pointer' : 'not-allowed'
                                                                                    }}
                                                                                />
                                                                            </Button>
                                                                        </Box>
                                                                    </Tooltip>
                                                                ) : null}





                                                                {isEditable ? (
                                                                    <Tooltip title="Video Konferans Ayarları"
                                                                        placement="top"
                                                                        arrow
                                                                    >
                                                                        <Box component="span" sx={{ display: 'inline-flex' }}>
                                                                            <VideoMenuGroup
                                                                                meeting={n}
                                                                                isEditable={isEditable}
                                                                                afterUpdateFunc={afterUpdateFunc}
                                                                            />
                                                                        </Box>
                                                                    </Tooltip>
                                                                ) : null}
                                                                <Tooltip title="Rapor Menüsü"
                                                                    placement="top"
                                                                    arrow
                                                                >
                                                                    <Box component="span" sx={{ display: 'inline-flex' }}>
                                                                        <ReportMenuGroup meeting={n} visibleMail={isManagementPage} />
                                                                    </Box>
                                                                </Tooltip>



                                                                <Snackbar
                                                                    open={copySuccess}
                                                                    autoHideDuration={4000}
                                                                    anchorOrigin={{ vertical: "top", horizontal: "right" }}
                                                                    onClose={() => setCopySuccess(false)}
                                                                >
                                                                    <Alert
                                                                        severity={snackbarMessage.includes("başarısız") ? "error" : "success"}
                                                                        onClose={() => setCopySuccess(false)}
                                                                    >
                                                                        {snackbarMessage}
                                                                    </Alert>
                                                                </Snackbar>
                                                                <Tooltip title="Toplantı Bilgi Önizleme"
                                                                    placement="top"
                                                                    arrow
                                                                >
                                                                    <Box component="span" sx={{ display: 'inline-flex' }}>
                                                                        <Button
                                                                            sx={buttonStyle}
                                                                            onClick={async () => {
                                                                                await handlePreviewButtonClick(n);
                                                                            }}
                                                                        >
                                                                            <VisibilityIcon sx={{ fontSize: iconFontSize, color: "#8EB68A" }} />
                                                                        </Button>
                                                                    </Box>
                                                                </Tooltip>
                                                                {isManagementPage && isRoleCheckList(userRoles, [1, 370, 373, 369, 372]) ? (
                                                                    <>
                                                                        {isEditable && (
                                                                            <Tooltip title="Toplantı Bilgi Güncelle"
                                                                                placement="top"
                                                                                arrow
                                                                            >
                                                                                <Box component="span" sx={{ display: 'inline-flex' }}>
                                                                                    <Button
                                                                                        color="info"
                                                                                        sx={buttonStyle}
                                                                                        onClick={async () => {
                                                                                            await handleUpdateButtonClick(n);
                                                                                        }}
                                                                                    >
                                                                                        <UpdateIcon sx={{ fontSize: iconFontSize }} />
                                                                                    </Button>
                                                                                </Box>
                                                                            </Tooltip>
                                                                        )}
                                                                        {isEditable && (
                                                                            <Tooltip title="Toplantı Silme"
                                                                                placement="top"
                                                                                arrow
                                                                            >
                                                                                <Box component="span" sx={{ display: 'inline-flex' }}>
                                                                                    <Button
                                                                                        color="error"
                                                                                        sx={buttonStyle}
                                                                                        onClick={async () => {
                                                                                            await handleDeleteButtonClick(n);
                                                                                        }}
                                                                                    >
                                                                                        <DeleteIcon sx={{ fontSize: iconFontSize }} />
                                                                                    </Button>
                                                                                </Box>
                                                                            </Tooltip>
                                                                        )}





                                                                    </>
                                                                ) : null}
                                                            </>
                                                        </TableCell>
                                                        {
                                                            isManagementPage && isRoleCheckList(userRoles, [1, 370, 373, 369, 372]) ? null : (
                                                                <TableCell></TableCell>
                                                            )
                                                        }
                                                    </TableRow>
                                                );
                                            })
                                        ) : (
                                            <TableRow>
                                                <TableCell colSpan={8} align="center">Toplantı Bulunamadı</TableCell>
                                            </TableRow>
                                        )}
                                        {
                                            <MeetingUsersDialog
                                                open={openUserList}
                                                onClose={() => setOpenUserList(false)}
                                                userListData={userListData}
                                                userType={userType}
                                            />
                                        }
                                    </TableBody>
                                    <TableFooter>
                                        <TableRow>
                                            <TablePagination
                                                count={data.length}
                                                rowsPerPage={rowsPerPage}
                                                page={page}
                                                onPageChange={(e, page) => setPage(page)}
                                                onRowsPerPageChange={(e) => setRowsPerPage(Number(e.target.value))}
                                                labelRowsPerPage={"Görüntülenecek Satır"}
                                                rowsPerPageOptions={[10, 50, 100, { label: "Tümü", value: -1 }]}
                                                showFirstButton
                                                sx={paginationStyle}
                                            />
                                        </TableRow>
                                    </TableFooter>
                                </Table>
                            </div>
                        </div>

                        <AddUpdateMeetingDialog
                            onClose={closeDialog}
                            open={addMeetingDialogStatus}
                            afterUpdateFunc={afterUpdateFunc}
                            addAfterTable={addAfterTable}
                        />

                        <PreviewMeetingDialog
                            meeting={selectedPreviewMeeting}
                            onClose={() => setPreviewMeetingDialogStatus(false)}
                            open={previewMeetingDialogStatus}
                        />
                    </>

                )
            }



        </Paper >

    );

}

export default MeetingDataTable